<template>
  <div
    class="popin-overlay"
    :class="[currentTheme]"
    @click="closePopin"
  >
    <transition
      name="fade-slide-left"
      appear
    >
      <div
        class="popin-content"
        @click.stop
      >
        <button
          class="close-button"
          @click="closePopin"
        >
          <CloseIcon />
        </button>
        <article :class="`collections-${this.$route.params.collectionId}-pattern-teaser`">
          <section>
            <PageTitle
              :title="currentCollection.genie"
              :collection="currentCollection"
              class="title"
            />
            <div
              class="content"
              v-html="$config.teaser[currentCollection.id]"
            />
          </section>
          <div class="picture">
            <div class="common-teaser-photo-1" />
            <div class="common-teaser-photo-2" />
            <div class="common-teaser-photo-3" />
            <div class="common-teaser-photo-4" />
          </div>
        </article>
      </div>
    </transition>
  </div>
</template>

<script>
import PageTitle from '@/components/common/PageTitle.vue';
import CloseIcon from '@/assets/images/common/icons/close.svg?inline';

export default {
  name: 'Popin',
  components: {
    PageTitle,
    CloseIcon,
  },
  computed: {
    currentTheme() {
      return `${this.$route.params.collectionId}-theme`;
    },

    currentCollection() {
      return this.$getCollectionById(this.$route.params.collectionId);
    },
  },
  mounted() {
    const root = document.getElementsByTagName('body')[0];
    root.classList.add('app-no-scroll-desktop');
  },
  beforeDestroy() {
    const root = document.getElementsByTagName('body')[0];
    root.classList.remove('app-no-scroll-desktop');
  },
  methods: {
    closePopin() {
      this.$router.push('/');
    },

  },
};
</script>

<style lang="stylus" scoped>
.popin-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8)
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  color: var(--text-color);

  +mobile() {
    position: absolute;
  }
}

// uncomment this block to limit coin to 100vh
.popin-content {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  +mobile() {
    width: 100vw;
    top: 0;
    right: 0;
  }

  > article {
    border-radius: 12px;
    width: min-content;
    height: auto;
    padding: 20px;
    background-color: var(--main-color);
    background-repeat: repeat;
    display: grid;
    gap: 170px;
    grid-template-columns: 1fr 1fr;
    border: 1px solid var(--white-color);

    +below-h(550px){
      gap: 120px;
    }

    +mobile() {
      grid-template-columns: 1fr;
      grid-template-rows: auto auto;
      justify-items: center;
      padding: 10px;
      margin: auto;
      gap: 20px;
      width: 100%;
      height: 100vh;
      max-height: 800px;
      border-radius: 0px;
      border: none;
    }

    section {
      width: 330px;
      +mobile() {
        width: 100%;
        max-width: 347px;
        align-self: flex-end;
      }
      .title {
        margin-top: 20px;

        +mobile() {
          margin: 40px 0px 0px;
        }
      }

      .content {
        padding-left: 50px;
        text-align: left;
        margin-top: 15px;
        font-size: 15px;
        line-height: 1.4;
        +mobile() {
          padding-left: 0px;
        }
      }
    }

    .picture {
      border: 1px solid var(--white-color);
      width: min-content;
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr;
      margin: auto;

      > div {
        width: auto;
        background-size: cover;
        grid-column: 1;
        grid-row: 1;
        opacity: 0;
        --animationTotalDuration: 12s;
        animation: frameAnimation var(--animationTotalDuration) infinite;

        +desktop() {
          max-height: calc(100vh - 62px);
          min-height: 320px;
        }

        &:nth-child(1) {
          animation-delay: 0s;
        }

        &:nth-child(2) {
          animation-delay: calc(var(--animationTotalDuration) * 0.25);
        }

        &:nth-child(3) {
          animation-delay: calc(var(--animationTotalDuration) * 0.5);
        }

        &:nth-child(4) {
          animation-delay: calc(var(--animationTotalDuration) * 0.75);
        }
      }
    }

    @keyframes frameAnimation {
      0% {
        opacity: 0;
        filter: brightness(2);
      }
      25% {
        filter: brightness(1);
        opacity: 1;
      }
      50% {
        opacity: 0;
      }
      100% {
        opacity: 0;
      }
    }
  }
}

.close-button {
  position: absolute;
  top: 50%;
  left: -50px;
  appearance: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  background var(--white-color)
  border-radius: 50%;
  padding: 10px;
  line-height: 0;
  transform: translateY(-50%);
  transition: all 0.3s ease;

  +mobile() {
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
  }

  &:hover {
    background var(--text-color)
    transform: translateY(-50%) scale(1.2) ;
  }

  svg {
    margin: 0;
    padding: 0;
    g g {
      stroke: var(--inverted-text-color);
    }
  }
}
</style>
